module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Zwischbergen_COA-891848635ab282e3d89492c8b8569602.svg";